module.exports = __webpack_public_path__ + "media/images/badge/coppa-italia-finalista-ea081c498872e7d6367f27bdb5f2c21a.png";